// extracted by mini-css-extract-plugin
export default {"wrapper":"PhotoUpload--wrapper--a93bc2","isDragging":"PhotoUpload--isDragging--995492","label":"PhotoUpload--label--7f35eb"};